import {IdCodeNameModel} from "common-shared";
import {Type} from "class-transformer";
import {ProcessSelectorModel} from "./process-selector.model";
import {MasterInputInstructionModel, MasterOutputInstructionModel} from "./master-input-instruction.model";
import {MasterUseInstructionModel} from "./master-use-instruction.model";
import {MasterOperationModel} from "./master-operation.model";
import { PropertyMappingModel } from "../../properties/models/property-mapping.model";
import {ExpressionModel} from "../../common/expression.model";
import {SpecLineModel} from "../../properties/models/spec-line.model";

export class TaskSelectorModel extends IdCodeNameModel {
  @Type(() => PropertyMappingModel)
  Mappings: PropertyMappingModel[] = [];
  ValidCondition: ExpressionModel = new ExpressionModel();
  Sequence?: number;
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];
  SourceCode?: string;

  constructor(init?: Partial<ProcessSelectorModel>) {
    super();
    Object.assign(this, init);
  }

  isValid(): boolean {
    return this.Specs.every(spec => spec.isValid());
  }
}

export class TaskSelectorWithInstructionsModel {
  @Type(() => TaskSelectorModel)
  TaskSelector: TaskSelectorModel;
  @Type(() => MasterInputInstructionModel)
  MasterInputInstructions: MasterInputInstructionModel[] = [];
  @Type(() => MasterUseInstructionModel)
  MasterUseInstructions: MasterUseInstructionModel[] = [];
  @Type(() => MasterOutputInstructionModel)
  MasterOutputInstructions: MasterOutputInstructionModel[] = [];

  constructor(init?: Partial<TaskSelectorWithInstructionsModel>) {
    Object.assign(this, init);
  }

  public static convertTo(ts: TaskSelectorModel, mo: MasterOperationModel): TaskSelectorWithInstructionsModel {
    return new TaskSelectorWithInstructionsModel({
      TaskSelector: ts,
      MasterInputInstructions: mo.MasterInputInstructions.filter(mii => mii.TaskSelectorId === ts.Id),
      MasterUseInstructions: mo.MasterUseInstructions.filter(mui => mui.TaskSelectorId === ts.Id),
      MasterOutputInstructions: mo.MasterOutputInstructions.filter(moi => moi.TaskSelectorId === ts.Id)
    });
  }
}
